import { openBlock as e, createElementBlock as t, createStaticVNode as a } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, o = /* @__PURE__ */ a('<g clip-path="url(#a)"><path d="M12.596 1.075a1 1 0 0 1 1.414 0l1.414 1.414a1 1 0 0 1 0 1.415l-2.828-2.829Z"></path><path fill-rule="evenodd" d="M11.12 8.207 2.93 15.53a1 1 0 0 1-1.374-.038l-.548-.549a1 1 0 0 1-.039-1.373l7.323-8.191 3.597-3.597 2.828 2.829-3.597 3.596Zm1.476-3.596-.707-.707L9.382 6.41l-.137.154.69.69.154-.137 2.507-2.506Zm-3.78 3.645-.573-.572-4.825 5.398 5.398-4.826Z" clip-rule="evenodd"></path></g><defs><clipPath id="a"><path d="M0 0h16v16H0z"></path></clipPath></defs>', 2), c = [
  o
];
function d(p, h) {
  return e(), t("svg", l, [...c]);
}
const r = { render: d };
export {
  r as default,
  d as render
};
